import axios from "axios";

import AuthStore from "modules/login/store/AuthStore";
import encryptData from "./encrypData";
import StorageKeys from "constants/StorageKeys";
import QmsStorageKeys from "constants/QmsStorageKeys";
import getCookie from "./journeyIdCookie/getJourneyId";
import * as APITypes from "../constants/API"

const getSpDetailsForSamsQms = async (journey_id) => {
    let response = await axios.get(`${APITypes.GET_SPCODE_DETAILS}?journey_id=${journey_id}`);
    if (response?.status === "success") {
        const encryptSPCode = await encryptData(response?.data?.sp_code)
        let spResponse = await AuthStore.getHLAgentApp(encryptSPCode);
        if (spResponse?.response_data) {
            localStorage.setItem(StorageKeys.ULIP_TRAINING, spResponse?.response_data?.agentHierarchyResponse?.agent_details?.ulip_training);
            localStorage.setItem(StorageKeys.SUB_CHANNEL_CODE, spResponse?.response_data?.agentHierarchyResponse?.main_channel_code);
            localStorage.setItem(QmsStorageKeys.ORIGANAL_DESIGNATION_CODE, spResponse?.response_data?.agentHierarchyResponse?.agent_details?.designation_code);
            let designation_code = spResponse?.response_data?.agentHierarchyResponse?.agent_details?.designation_code
            let isposp = designation_code ? designation_code?.toLowerCase()?.includes('posp') : false
            localStorage.setItem(StorageKeys.IS_POSP, isposp)
        }
    }
}
export default getSpDetailsForSamsQms;